import React from 'react';
import MetaInfo from "../common/MetaInfo";
import FormatDate from "../common/FormatDate";
import Loading from "../vulcan-core/Loading";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';

const styles = defineStyles('UsersAutoCompleteHit', (theme: ThemeType) => ({
  root: {
    cursor: "pointer"
  }
}));

const UsersAutoCompleteHit = ({document}: {
  document: SearchUser
}) => {
  const classes = useStyles(styles);

  if (document) {
    return <div className={classes.root}>
      <MetaInfo>
        {document.displayName}
      </MetaInfo>
      <MetaInfo>
        {document.karma} karma
      </MetaInfo>
      <MetaInfo>
        <FormatDate date={document.createdAt}/>
      </MetaInfo>
    </div>
  } else {
    return <Loading />
  }
};

export default UsersAutoCompleteHit;



